<script setup lang="ts">
import { useQuery } from '@tanstack/vue-query'
import { rankTopN } from '@mp/api/mchTradeData/BpCompanyIndexDashboardController.js'
import type { Ref } from 'vue'
import { computed, inject } from 'vue'
import { yunFormat } from '@mp/utils'

import Top1 from '@/assets/top1.svg'
import Top2 from '@/assets/top2.svg'
import Top3 from '@/assets/top3.svg'
import { useRouter } from 'vue-router'

const router = useRouter()
const officeCode = inject<Ref<string>>('officeCode')
const { data: tableData } = useQuery({
  enabled: computed(() => !!officeCode?.value),
  queryKey: ['company/index/dashboard/statement/trade/today/rank/topN', officeCode],
  queryFn: () => rankTopN({
    officeCode: officeCode?.value,
  }),
  select: res => res.data?.mchTradeStats ?? [],
})

function handleToOrder(row: APIMchTradeData.BpTradeInfoDto) {
  router.push({
    name: 'TransactionOrder',
    query: {
      mchId: row.mchId,
    },
  })
}
</script>

<template>
  <section class="bg-white p-4 rounded-lg relative overflow-hidden mt-4" style="--el-border-color-light: transparent">
    <div class="flex justify-between">
      <label class="text-base text-n-800 flex font-medium">商户Top10</label>
    </div>

    <el-table height="332" class="mt-4" :data="tableData">
      <el-table-column label="排名" sortable width="80" prop="string" fixed="left">
        <template #default="{ $index }">
          <img v-if="$index < 3" :src="$index === 0 ? Top1 : $index === 1 ? Top2 : Top3" alt="" class="w-5 h-5">
          <span v-else class="text-n-800">{{ $index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="商户号" prop="mchId" width="150" />
      <el-table-column label="商户名称/简称" prop="mchName" min-width="200" />
      <el-table-column label="所属层级" width="150">
        <template #default="{ row }">
          <el-tooltip
            :content="row.officeName"
          >
            {{ row.officeName?.split('/')?.at(-1) }}
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="交易金额" sortable prop="paidAmount" align="right" width="120">
        <template #default="{ row }">
          {{ yunFormat(row.turnover) }}
        </template>
      </el-table-column>
      <el-table-column label="交易笔数" sortable prop="tradeCount" align="center" width="120" />
      <el-table-column label="活跃门店数" sortable prop="activeShopCount" align="center" width="120" />
      <el-table-column label="操作" width="60" fixed="right">
        <template #default="{ row }">
          <el-button
            :id="`DASHBOARD_TOP10_VIEW_${row.mchId}`" v-track
            type="text" @click="handleToOrder(row)"
          >
            查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </section>
</template>
